import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Eklektika Lexi",
  publicUrl: "https://www.lexi.eklektika.pl",
  pwaServiceName: "Eklektika Lexi",
  appLogoPath: "/partner/eklektika/logo.png",
  appLogoHeight: "60px",
  landingLogoPath: "/partner/eklektika/logo.png",
  landingLogoHeight: "60px",
  hubLogoPath: "/partner/eklektika/logo.png",
  hubLogoHeight: "60px",
  favicon: "/partner/eklektika/icon.png",
  pwaIcons: [
    {
      src: "/partner/eklektika/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "ai@lexi.eklektika.pl",
  adminEmail: "helpdesk@eklektika.pl",
  adminPhoneNumber: "+48 575 003 120",
  reviewLink: "https://forms.gle/PLZx9Um6EfomPWwL8",
  copyright: "Eklektika sp. z o. o.",
  showLanguageGuides: true,
  bioPrompt: `
  You are a language tutor at Eklektika Lexi.

  Eklektika is a language training school with over 20 years of experience. More than 200 companies have trusted us to help improve the language skills of over 25,000 participants. We focus on high-quality service, offering experienced teachers and digital tools that support learning. Our clients include some of the largest industry leaders and organizations from sectors such as E-Commerce, IT and Finance.
  We handle all aspects of training — from assessing needs and designing courses to tracking progress and reporting results. By using data to guide our decisions and staying open to new ideas and the latest educational tools, we provide flexible, modern solutions that meet the needs of today's organizations.
  `,
  tocLink: "https://eklektika.pl/regulamin-uslugi-lexi-ai/",
  privacyLink: "https://eklektika.pl/polityka-prywatnosci-lexi-ai/",
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-tertiary-600)",
      speakInputRecording: "var(--chakra-colors-brand-tertiary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-tertiary-900)",
    },
  },
  colors: {
    primary: {
      main: "#e50059",
      mainContrast: "#fff",
      "50": "#fef5f8",
      "100": "#fbd7e5",
      "200": "#f7b2cd",
      "300": "#f282ae",
      "400": "#ef639a",
      "500": "#e92b75",
      "600": "#d10051",
      "700": "#aa0042",
      "800": "#910038",
      "900": "#6c002a",
    },
    secondary: {
      main: "#003d77",
      mainContrast: "#fff",
      "50": "#f5f8fa",
      "100": "#d8e1ea",
      "200": "#b6c8d8",
      "300": "#8ea9c3",
      "400": "#7798b7",
      "500": "#5981a6",
      "600": "#3f6d98",
      "700": "#225789",
      "800": "#0f497f",
      "900": "#003465",
    },
    tertiary: {
      main: "#003d77",
      mainContrast: "#fff",
      "50": "#f5f8fa",
      "100": "#d8e1ea",
      "200": "#b6c8d8",
      "300": "#8ea9c3",
      "400": "#7798b7",
      "500": "#5981a6",
      "600": "#3f6d98",
      "700": "#225789",
      "800": "#0f497f",
      "900": "#003465",
    },
    gray: {
      "50": "#fafafa",
      "100": "#f1f1f1",
      "200": "#e7e7e7",
      "300": "#d4d4d4",
      "400": "#adadad",
      "500": "#7f7f7f",
      "600": "#545454",
      "700": "#373737",
      "800": "#202020",
      "900": "#191919",
    },
    pink: {
      "50": "#fef5f9",
      "100": "#fbd8e6",
      "200": "#f8b7d1",
      "300": "#f389b3",
      "400": "#ef649c",
      "500": "#e82272",
      "600": "#d00054",
      "700": "#ab0045",
      "800": "#870036",
      "900": "#660029",
    },
    red: {
      "50": "#fef5f4",
      "100": "#fbd8d5",
      "200": "#f7b6ae",
      "300": "#f2887d",
      "400": "#ee6b5d",
      "500": "#e93a26",
      "600": "#d21500",
      "700": "#aa1100",
      "800": "#910f00",
      "900": "#6b0b00",
    },
    orange: {
      "50": "#fefaf4",
      "100": "#fbebd4",
      "200": "#f5d4a1",
      "300": "#eeb156",
      "400": "#e68e0b",
      "500": "#c97800",
      "600": "#aa6600",
      "700": "#875100",
      "800": "#6b4000",
      "900": "#583500",
    },
    yellow: {
      "50": "#fefefa",
      "100": "#fcfae0",
      "200": "#f6f0a2",
      "300": "#ede352",
      "400": "#decf00",
      "500": "#b6ab00",
      "600": "#928800",
      "700": "#726a00",
      "800": "#555000",
      "900": "#464200",
    },
    green: {
      "50": "#f3fef9",
      "100": "#b9f8df",
      "200": "#5beeb3",
      "300": "#00da82",
      "400": "#00bf72",
      "500": "#00a462",
      "600": "#008851",
      "700": "#006a3f",
      "800": "#005734",
      "900": "#00472b",
    },
    teal: {
      "50": "#f0fcfd",
      "100": "#bbf2f8",
      "200": "#77e5f1",
      "300": "#0ed1e6",
      "400": "#00b1c5",
      "500": "#0097a8",
      "600": "#007b88",
      "700": "#00606a",
      "800": "#005059",
      "900": "#004249",
    },
    cyan: {
      "50": "#f4fbfe",
      "100": "#ceeefa",
      "200": "#b8e7f8",
      "300": "#9edef5",
      "400": "#4bc2ed",
      "500": "#1eb2e8",
      "600": "#00a0da",
      "700": "#0084b4",
      "800": "#006d94",
      "900": "#005473",
    },
    blue: {
      "50": "#f1f6fe",
      "100": "#cddffa",
      "200": "#a8c8f6",
      "300": "#7fadf2",
      "400": "#5794ee",
      "500": "#327cea",
      "600": "#0861e6",
      "700": "#0049b6",
      "800": "#003c96",
      "900": "#00317b",
    },
    purple: {
      "50": "#f9f5fe",
      "100": "#e8d9fb",
      "200": "#d6bcf8",
      "300": "#bc92f4",
      "400": "#aa74f1",
      "500": "#9049ec",
      "600": "#7a25e9",
      "700": "#5e00db",
      "800": "#4f00b6",
      "900": "#3c008a",
    },
  },
};
